/**
 * Search, as a place rather than a popover.
 *
 * The query lives in the URL, so a search can be linked to, reopened from
 * history and shared — and so the magnifier in a room header can hand over a
 * scope (`/search?q=in:%23prosjekt-x`) without the two screens sharing state.
 * The panel itself owns everything else; this only sits it inside the shell.
 */

import type { ReactElement } from 'react'
import { useSearchParams } from 'react-router-dom'

import { SearchPanel } from '@/components/SearchPanel'

export function SearchPage(): ReactElement {
  const [params] = useSearchParams()

  return <SearchPanel initialQuery={params.get('q') ?? ''} autoFocus />
}

export default SearchPage
